<template>
  <div class="page-event-detail-wrapper">
    <div class="page-event-detail" v-if="Object.keys(detail).length">
      <event-detail-menu
        v-if="!isMobile"
        :res="detail.res"
        :showProcedure="!!detail.events_procedure_html"
        :showNotice="!!detail.events_notice_html"
      />
      <div class="event-detail-container">
        <event-detail-info
          :title="detail.title"
          :notice_image="detail.notice_image"
        />
        <event-detail-profile
          :events_profile_html="detail.events_profile_html"
          :begin_time="detail.begin_time"
          :end_time="detail.end_time"
          :country="detail.country"
          :province="detail.province"
        />
        <event-detail-guest :guests="detail.guests" />
        <event-detail-procedure v-if="detail.events_procedure_html" :events_procedure_html="detail.events_procedure_html" />
        <event-detail-notice v-if="detail.events_notice_html" :events_notice_html="detail.events_notice_html"/>
        <event-detail-review :res="detail.res" />
        <event-detail-download :res="detail.res" />
      </div>
    </div>
    <event-detail-status-sticky :detail="detail" />
    <com-fix v-if="Number($route.params.id)!==-99"></com-fix>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import service from '@/service'
import comFix from '@/components/com-fix'
import eventDetailReview from './event-detail-review'
import eventDetailProfile from './event-detail-profile'
import eventDetailGuest from './event-detail-guest'
import eventDetailProcedure from './event-detail-procedure'
import eventDetailDownload from './event-detail-download'
import eventDetailNotice from './event-detail-notice'
import eventDetailInfo from './event-detail-info'
import eventDetailStatusSticky from './event-detail-status-sticky'
import eventDetailMenu from './event-detail-menu'
import utils from '../../util'

export default {
  data () {
    return {
      detail: {}
    }
  },
  components: {
    comFix,
    eventDetailMenu,
    eventDetailReview,
    eventDetailProfile,
    eventDetailGuest,
    eventDetailProcedure,
    eventDetailDownload,
    eventDetailInfo,
    eventDetailStatusSticky,
    eventDetailNotice
  },
  created () {
    // id为 -99 为后台预览时用
    if (Number(this.$route.params.id) === -99) {
      window.addEventListener('message', this.messageListener)
      return
    }

    service.getEventDetail({ event_id: this.$route.params.id })
      .then((data) => {
        // 移动端自动跳转到小程序
        if (this.isMobile) {
          utils.goMpActivityDetail({ id: this.$route.params.id })

          return
        }

        this.detail = data
        document.title = `${data.title} | TGO 鲲鹏会`
      })
      .catch((err) => { console.error(err) })
  },
  methods: {
    messageListener (event) {
      if (Object.keys(this.detail).length) return
      let postInfo = typeof event.data === 'string' && event.data ? JSON.parse(event.data) : { data: {} }
      this.detail = postInfo.data
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  beforeDestroy () {
    if (Number(this.$route.params.id) !== -99) return
    window.removeEventListener('message', this.messageListener)
  }
}
</script>

<style scoped lang='scss'>
@import '../../style/bulma/app.sass';

.section-content {
  line-height: 32px;
  color: #4A4A4A;
}

.page-event-detail-wrapper {
  background-color: #f4f3f3;
}

.page-event-detail {
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: flex-end;
  width: 1080px;
  padding-bottom: 34px;
  margin: 0 auto;
  @include mobile {
    justify-content:center;
    width: auto;
    background-color: #fff;
  }
}

.event-detail-container {
  overflow: hidden;
  width: 895px;
  margin-top: 20px;
  padding: 41px 60px 15px 60px;
  background: #FFF;

  @include mobile {
    width: 92vw;
    padding: 0;
    margin-top: 30px;
  }
}

.event-notice {
 .section-content {
    margin-bottom: 110px;
  }
}
</style>
